import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Alert,
  Button,
  FormText,
} from "reactstrap";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import ModalConfirm from "../components/modalConfirm";
import { Trans, useTranslation } from "react-i18next";

const PasswordResetModal = ({ isPasswordResetModalOpen, setIsPasswordResetModalOpen, currentUser }) => {
    const { t } = useTranslation();
    const [success, setSuccess] = useState(false);
    const [errorPut, setErrorPut] = useState(false);
  
    const [openModal, setToggleModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);

    const toggleModals = () => {
      setIsPasswordResetModalOpen(!isPasswordResetModalOpen);
      setToggleModal(!openModal);
    };

    const Schema = Yup.object().shape({
      password: Yup.string().required(t("general.passwordResetModal.body.form.message.currentPasswordRequired")),
      newpassword: Yup.string()
        .min(10, t("general.passwordResetModal.body.form.message.newPasswordMinLength"))
        .required(t("general.passwordResetModal.body.form.message.newPasswordRequired"))
        .test(
          "different-from-old",
          t("general.passwordResetModal.body.form.message.newPasswordDifferentFromOld"),
          function (newpassword) {
            return newpassword !== this.parent.password;
          }
        ),
      passwordConfirmation: Yup.string().oneOf([Yup.ref('newpassword'), null], t("general.passwordResetModal.body.form.message.newPasswordConfirmation"))
    });

  return (
    <>
      <Modal isOpen={isPasswordResetModalOpen} backdrop="static" keyboard={false}>
        <ModalHeader>
          {t("general.passwordResetModal.header")}
        </ModalHeader>
        <ModalBody>
            <Formik
              initialValues={{password:'', newpassword: '', passwordConfirmation: '',}}
              validationSchema={Schema}
              onSubmit={({password, newpassword, passwordConfirmation},{ setStatus, setSubmitting }) => {
                setStatus();
                setToggleModal(true);
                setDataModal({
                  old_password: password,
                  new_password: newpassword
                });
              }}
              render={({ errors, status, touched, isSubmitting, setFieldValue }) => {
                return (
                  <Form>
                    <FormGroup>
                      <Label>{t("general.passwordResetModal.body.form.label.currentPassword")}</Label>
                      <Field
                      name="password"
                      type="password"
                      className={
                        "form-control" +
                        (errors.password && touched.password ? " is-invalid" : "")
                      }
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="invalid-feedback"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>{t("general.passwordResetModal.body.form.label.newPassword")}</Label>
                      <Field
                        name="newpassword"
                        type="password"
                        className={
                          "form-control" +
                          (errors.newpassword && touched.newpassword
                          ? " is-invalid"
                          : "")
                        }
                      />
                      <ErrorMessage
                        name="newpassword"
                        component="div"
                        className="invalid-feedback"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>{t("general.passwordResetModal.body.form.label.repeatNewPassword")}</Label>
                      <Field
                        name="passwordConfirmation"
                        type="password"
                        className={
                          "form-control" +
                          (errors.passwordConfirmation && touched.passwordConfirmation
                          ? " is-invalid"
                          : "")
                        }
                      />
                      <ErrorMessage
                        name="passwordConfirmation"
                        component="div"
                        className="invalid-feedback"
                      />
                    </FormGroup>
                    <Button type="submit" color="success" className="float-right">
                      {t("general.passwordResetModal.body.form.button.submit")}
                    </Button>
                  </Form>
                );
              }}
            />
            <div style={{paddingTop: 20}}>
            {success && <Alert color="success">{t("general.passwordResetModal.message.success")}</Alert>}
            {errorPut && <Alert color="danger">{t("general.passwordResetModal.message.error")}</Alert>}
            </div>
            {openModal && (
              <ModalConfirm
                openModal={openModal}
                setToggleModal={toggleModals}
                dataModal={dataModal}
                title={t("general.passwordResetModal.modal.confirm.header")}
                body={t("general.passwordResetModal.modal.confirm.body")}
                setSuccess={setSuccess}
                setError={setErrorPut}
                method={"POST"}
                apiURL={`users/${currentUser.id}/change-password`}
                setRedirect={false}
              />
            )}
        </ModalBody>
        <ModalFooter>
          <FormText color="muted">
            <Trans i18nKey="general.passwordResetModal.footer.note">
              <strong>Note: </strong>It's been a while since you last updated your password. For your security, please reset your password.
            </Trans>
          </FormText>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PasswordResetModal;
